import { render } from "./TabBal.vue?vue&type=template&id=08c0e214&scoped=true"
import script from "./TabBal.vue?vue&type=script&lang=js"
export * from "./TabBal.vue?vue&type=script&lang=js"

import "./TabBal.vue?vue&type=style&index=0&id=08c0e214&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c0e214"]])

export default __exports__